


import React from 'react';

import ReactDOM from 'react-dom';
import { Collapse,CollapseItem ,Popover,Rate} from 'element-react';
import { Button, Input, Switch, DatePicker, Image, ConfigProvider} from '@jd/find-react';
import zhCN from '@jd/find-react/es/locale/zh_CN';
 
import KeeVue from '../base/KeeVue.js'
import FeasComponents from '../render/FeasComponents.js'
import FsSelect from './FsSelect.js'
import FsIcon from './FsIcon.js'
import FsColor from './FsColor.js'

import FsPicSelect from './FsPicSelect.js'
import FsCalendar from './mobile/FsCalendar.js'

import FsUpload from '../element/FsUpload.js'

import FsCodeEditor from './FsCodeEditor.js'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-CN');

const { RangePicker } = DatePicker;



const { TextArea } = Input;

export default class FsInput extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {

				randId: this.getRandString(),

				pagination: {
					total: 0,
					rows: 10,
					page: 1,
					totalPage: 0,
				},
				sort: 'id',
				order: 'desc',
				groupby: '',
				listName: '',
				isShowGrid: false,
				pageSize: 10,
				currentPage4: 1,
				height: 500,
				gridData: [],
				hasFixedField: false,
				componentState: {
					refreshTime: 0
				},
				showType: "grid", // 是否采用grid，或card方式显示
				configWindow: null,
				dtoFields: '',
				selectedRows: [],
				  restaurants:[],
				isMouseOver:false,
				inputValue:'',
				value:'',
				titleType:false
			}

}

componentWillMount(){
			var that = this;
			// if(this.props.component.name === 'fs-input'||this.props.component.name === 'fs-ztree'||this.props.component.name === 'fs-switch'||this.props.component.name === 'fs-textarea'||this.props.component.name === 'fs-date'||this.props.component.name === 'fs-rate') {
			// 	this.registComponent();
			// }
			
			
			// 不能直接注册，有些需要自己注册
			
			if(this.props.component.name!='fs-code-editor')
			{
				this.registComponent();
			}
			
			
			if(this.props.component.name==='fs-input')
			{
				this.state.restaurants = this.loadAll();
			}
			
			
			
			// if(this.props.component.cp.subType=='dateRange')
			// {
			// 	alert("xuanran "+"date");
			// }
			 
			if(this.props.component.name === 'fs-date' || this.props.component.name === 'fs-date-time')
			{
				if(this.props.component.cp.subType !== 'dateRange'){
					if(this.props.component.value)
					{
						if(this.props.component.name === 'fs-date'){
							var moment = window.moment(this.props.component.value,'YYYY-MM-DD');
							this.state.value= moment;
						} else {
							moment = window.moment(this.props.component.value,'YYYY-MM-DD HH:mm');
							this.state.value= moment;
						}
					}
					else
					{
						this.state.value= null;
					}
				}
			}
			else
			{
				this.state.value=this.props.component.value;
				if(this.state.value===null)
				{
					this.state.value = "";
				}
			}
			
			
		}
		componentDidMount(){
			//console.log(this.props,'componentDidMount')
		}
			itemClick=(item)=> {
			}
			validValue=(item)=> {

				if(this.props.debug)
				{
					return ;
				}
				
			
				var error = false;
				var errorMsg = "";
				
				item.error = error;
				item.errorMsg = errorMsg;
				
				if(item.type=='fs-switch')
				{
					if(item.cp.required  && item.cp.required === true)
					{
						if(item.value==false||item.value==true)
						{
							
						}
						else
						{
							error = true;
							errorMsg = "必填项";
							item.error = error;
							item.errorMsg = errorMsg;
						}
						return ;
					}
				}
				
				
				if(item.type === "dateRange") {
					if(item.cp.required  && item.cp.required === true) {
						var str = JSON.stringify(item.value);
						if(str.length < 26 || str.indexOf("N") !== -1) {
							error = true;
							errorMsg = "必填项";
						}
					}
				} else {
					if(item.cp.required  && item.cp.required === true) {
						if(this.isNotBlank(item.value) !== true) {
							error = true;
							errorMsg = "必填项";
						}
					}
				}
				if(item.cp.format  && item.cp.format !== ""&&item.value) {
					if(item.cp.format === "text") {
					}
					if(item.cp.format === "email" && item.value  && item.value !== "" && this.isEmail(item.value) === false) {
						error = true;
						errorMsg = "邮箱格式错误";
					}
					if(item.cp.format === "phone" && item.value  && item.value !== "" && this.isPhone(item.value) === false) {
						error = true;
						errorMsg = "电话格式错误";
					}
					if(item.cp.format === "tel" && item.value  && item.value !== "" && this.isTel(item.value) === false) {
						error = true;
						errorMsg = "手机号格式错误";
					}
					if(item.cp.format === "idcard" && item.value  && item.value !== "" && this.isIdCard(item.value) === false) {
						error = true;
						errorMsg = "身份证格式错误";
					}
					if(item.cp.format === "ip" && item.value  && item.value !== "" && this.isIp(item.value) === false) {
						error = true;
						errorMsg = "IP格式错误";
					}
					if(item.cp.format === "number" )
					{
						if(item.cp.decimal){
							if(item.value  && item.value !== "" && this.isNumLen(item.value, item.cp.decimal) === false){
								error = true;
								errorMsg = "不是数字或长度不符";
							} else {
								return item.value;
							}
						} else {
							if(item.value  && item.value !== "" && this.isNumber(item.value) === false) {
								error = true;
								errorMsg = "只能输入数字";
							}
							else
							{
								item.value=parseInt(item.value)
							}
						}
					}
					if(item.cp.format === "float" )
					{
						if( item.value  && item.value !== "" && this.isFloat(item.value) === false) {
						error = true;
						errorMsg = "只能输入小数";
						}
						else
						{
							item.value=parseFloat(item.value);
						}
					}
					if(item.cp.format === "int" && item.value  && item.value !== "" && this.isInt(item.value) === false) {
						error = true;
						errorMsg = "只能输入正整数";
					}
				}
				if(item.cp.minLength  && item.cp.minLength !== "") {
					if(item.value  && item.value.length < parseInt(item.cp.minLength)) {
						error = true;
						errorMsg += "输入长度最小为" + item.cp.minLength + "个字符";
					}
				}
				if(item.cp.maxLength  && item.cp.maxLength !== "") {
					if(item.value  && item.value.length > parseInt(item.cp.maxLength)) {
						error = true;
						errorMsg += "输入长度最大为" + item.cp.maxLength + "个字符";
					}
				}
				if(item.cp.format === 'number' || item.cp.format === 'float' || item.cp.format === 'int') {
					if(this.isNotBlank(item.cp.min)) {
						if(item.value  && parseInt(item.value) < parseInt(item.cp.min)) {
							error = true;
							errorMsg += "不能小于值" + item.cp.min + "";
						}
					}
					if(this.isNotBlank(item.cp.max)) {
						if(item.value  && parseInt(item.value) > parseInt(item.cp.max)) {
							error = true;
							errorMsg += "不能大于值" + item.cp.max + "";
						}
					}
				}
				if(item.cp.field === 'cp.decimal' || item.cp.field === 'cp.minLength' || item.cp.field === 'cp.maxLength'){
					if(item.value){
						if(!Number.isInteger(Number(item.value))){
							error = true;
							errorMsg = '必须是整数'
						}else {
							item.value=parseInt(item.value);
						}
					} 
				}
				item.error = error;
				item.errorMsg = errorMsg;
			}
			handleBlur=(item)=> {
				if(this.props.debug)
				{
					return ;
				}
				if(item.value && typeof item.value === "string")
					item.value = item.value.trim();
				this.validValue(item);
				this.refresh();
			}
			onEnter=(item)=> {
				window.CReactMap[item.viewName].$emit(item.alias + ".enter", item, this.props.po, this.thisForm, this.parentForm);
			}
			reactValueChange=(e)=>{
				
				 
				 
				var item = this.props.component;
				var oldValue = item.value;
				item.value=e.target.value;
				var newValue=e.target.value;
				
				this.state.value = newValue;
				 
				var that = this;
				
				// 使用目标对象的校验参数
				if(this.props.po&&this.props.po.cp&&this.props.po.cp.maxLength)
				{
					//item.cp.maxLength = this.props.po.cp.maxLength;
				}
				
				 that.validValue(item);
				
				 
				
				
				// console.log("jiaoyan:"+item.error+item.cp.maxLength);
				// console.log(item);
				if(item.error === false||!item.value) {
					
					//alert(""+item.message);
					if(item.type === 'text' && "number" === item.cp.format && this.isNotBlank(item.value)) {
						item.value = parseInt(item.value);
					}
					if(that.props.po!==null)
					{
						this.setVueAttr(that.props.po, item.cp.field, item.value);
					}
					
					this.$emit("command", "change", item, this.props.po, this.thisForm, this.parentForm);
					this.$emit("change", item.value, this.props.po);
					this.sendPageEvent("change",item.value, this.props.po)
					 
					//this.sendEvent("refresh"); 
					this.refresh();
					if(that.props.po&&that.props.po.id)
					{
						//this.refreshComponent();
						//this.sendEvent(that.props.po.id+".render");
					}
					
				}
				else
				{
					// console.log("+"+item.cp.maxLength)
					// if(item.cp.maxLength)
					// {
						
						 
					// 	if(newValue.length>item.cp.maxLength&&item.cp.maxLength>1)
					// 	{
							 
					// 		item.value=oldValue;
					// 		this.state.value = oldValue;
					// 	}
						
					// 	this.refresh();
					// }
					this.refresh();
				}
				
			}
			valueDateChange=(newValue)=> {
				// 	this.state.value= moment;')
				// this.log("new value:"+newValue);
				var item = this.props.component;
				item.value=newValue;
				 
				var that = this;
				that.validValue(item);
				if(item.error === false) {
					if(item.type === 'text' && "number" === item.cp.format && this.isNotBlank(item.value)) {
						item.value = parseInt(item.value);
					}
					if(that.props.po!==null)
					{
						this.setVueAttr(that.props.po, item.cp.field, item.value);
					}
				}
				else
				{
					//alert(item.errorMsg);
				}
				//this.$emit("command", "change", item, this.props.po, this.thisForm, this.parentForm);
				this.$emit("change", item.value, this.props.po);
				 this.sendPageEvent("change",item.value, this.props.po)
				 // this.log("new value2:"+item.value);
				 
				 // console.log(JSON.stringify(this.props.component));
				
				if(that.props.po&&that.props.po.id)
				{
					//this.sendEvent(that.props.po.id+".render");
					this.refreshComponent();
				}
				this.setState(this.state);
			
			}
			
			valueChange=(newValue)=> {
				
				// this.log("new value:"+newValue);
				var item = this.props.component;
				item.value=newValue;
				 
				var that = this;
				that.validValue(item);
				if(item.error === false) {
					if(item.type === 'text' && "number" === item.cp.format && this.isNotBlank(item.value)) {
						item.value = parseInt(item.value);
					}
					if(that.props.po!==null)
					{
						this.setVueAttr(that.props.po, item.cp.field, item.value);
					}
				}
				else
				{
					//alert(item.errorMsg);
				}
				this.$emit("command", "change", item, this.props.po, this.thisForm, this.parentForm);
				this.$emit("change", item.value, this.props.po);
				 
				 // this.log("new value2:"+item.value);
				 this.sendPageEvent("change",item.value, this.props.po)
				 // console.log(JSON.stringify(this.props.component));
				
				if(that.props.po&&that.props.po.id)
				{
					//this.sendEvent(that.props.po.id+".render");
					this.refreshComponent();
				}
				this.setState(this.state);

			}
					    querySearch(queryString, cb) {
		        console.log("执行querySearch");
        var restaurants = this.state.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        cb(results);
      }
      createFilter(queryString) {
        return (restaurant) => {
            console.log("createFilter:",restaurant);
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1 );
        };
      }
      loadAll() {
          var text = localStorage.getItem(this.props.component.viewName+"_"+this.props.component.alias);
          if(text)
          {
              return JSON.parse(text);
          }
          else
          {
            return [ ];
          }
      }
      add(){
          var value = this.props.component.value;
          if(value)
          {
             var text = localStorage.getItem(this.props.component.viewName+"_"+this.props.component.alias);
          var list =[];
             if(text)
             {
                 list  = JSON.parse(text);
                var flag = false;
                for (var t = 0;t <list.length ;t++) {
                    if(list[t].value===value)
                     {
                         flag = true;
                     }
                  }
                if(!flag)
                {
                    list.unshift({"value":value})
                }
              }
              else
              {
                  list.push({"value":value})
              }
              localStorage.setItem(this.props.component.viewName+"_"+this.props.component.alias,JSON.stringify(list));
               this.state.restaurants = list;
          }
      }
      handleSelect(item) {
        console.log(item);
        this.sendEvent("change",item.value);
      }
	  onClickFun(e){
		  e.stopPropagation()
		  console.log('标题模式被修改')
		  this.setState({titleType:true})
	  }
	  componentWillReceiveProps(nextProps){
		if(  this.props.component.name=='fs-date' &&this.props.component.cp.subType=='dateRange')
		{
			
		}
		else
		{
			if(this.props.component.name==='fs-date' || this.props.component.name === 'fs-date-time')
			{
				if(this.props.component.cp.subType !== 'dateRange'){
					if(this.props.component.value)
					{
						if(this.props.component.name === 'fs-date'){
							var moment = window.moment(this.props.component.value,'YYYY-MM-DD');
							this.state.value= moment;
						} else {
							moment = window.moment(this.props.component.value,'YYYY-MM-DD HH:mm');
							this.state.value= moment;
						}
					}
					else
					{
						this.state.value= null;
					}
				}
			}
			else
			if(this.state.value!==nextProps.component.value)
			{
				this.state.value = nextProps.component.value;
				if(this.state.value===null)
				{
				   this.state.value = "";
				}
				this.refresh();
			}
		}
		  
	  	
	  	
	  	 // else
	  	 // {
	  		//  this.log("不需要更新")
	  	 // }
	  	
	  }

	  renderItem(){
		  
		   
		  var type = this.props.component.name;
		// if(type=='fs-switch')
		//   {
		// 	  console.log("===========================");
		// 	  console.log(JSON.stringify(this.props.component));
		//   }
		  if((typeof this.props.component.value=="undefined"||this.props.component.value==null)&&type!='fs-date')
		  {
			 //console.log("value wei  null");

			 this.props.component.value = "";

		  }
		  
		  if(this.props.component.value===null)
		  {
			  //alert("weikongkongkong")
		  }

		  // if(typeof this.props.component.value=='string'&&type=='fs-date')
		  // {
			 //  this.props.component.value = null;
		  // }


		  var that  = this;
		   // console.log(this.props.component.name+" this.props.component.cp.editable:"+this.props.component.cp.editable);
		  //console.log(this.props.component.name+" this.props.editable:"+JSON.stringify(this.props.editable));
		  if((this.props.editable==false||this.props.component.cp.editable==false)&&type!='fs-upload'&&type!='fs-icon'&&type!='fs-code-editor'&&type!='fs-html-editor'&&type!='fs-cms-config'&&type!='fs-img'&&type!='fs-cascader'&&type!='fs-ztree'&&type!='fs-select'&&type!='fs-roles'&&type!='fs-users')
		  {
			  // 只读状态
			  return <div>{that.props.component.cp.filter? <div className="kee-static-div">
  						<div  >{that.props.component.htmlField}</div>
  					 </div>
					 :
  					  <div className="kee-static-div">{this.props.component.value} </div>

					}</div>
		  }
		  else
		  {

			 return    <div   style={{minHeight: '14px',width:'100%'}} 
			 // onMouseOver={(e)=>{e.stopPropagation();this.state.isMouseOver=true;this.refresh();}}
			 // onMouseOut= {(e)=>{e.stopPropagation();this.state.isMouseOver=false;this.refresh();}}
			  >
			  
			  {
				    type=='fs-input'&&( <Input  defaultValue={this.props.component.value} value={this.state.value}
					 
					size="middle"
					type="text" readOnly={this.props.debug==true}
					onBlur={()=>this.handleBlur(this.props.component)}   
					onChange={this.reactValueChange}
					autoComplete="off" placeholder={this.props.component.cp.help}></Input>)
			  } 
				 
			   {
				   type=='fs-icon' && <FsIcon
				   component={this.props.component}  po={this.props.po} keePage={this.props.keePage} thisForm={this.props.thisForm} name={this.props.name}
				   query={this.props.query}   debug={this.props.debug}
				    onChange={this.valueChange}
                    editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsIcon>
			   }
			   
			   {
			   				   type=='fs-color' && <FsColor
			   				   component={this.props.component}  po={this.props.po} keePage={this.props.keePage} thisForm={this.props.thisForm} name={this.props.name}
			   				   query={this.props.query}   debug={this.props.debug}
			   				    onChange={this.valueChange}
			        editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsColor>
			   }
			   
			   {
			   				   type=='fs-pic-select' && <FsPicSelect
			   				   component={this.props.component}  po={this.props.po} keePage={this.props.keePage} thisForm={this.props.thisForm} name={this.props.name}
			   				   query={this.props.query}   debug={this.props.debug}
			   				    onChange={this.valueChange}
			        editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsPicSelect>
			   }


			   {
				   type=='fs-textarea' && <TextArea  defaultValue={this.props.component.value} value={this.state.value} 
				   onBlur={()=>this.handleBlur(this.props.component)}    onChange={this.reactValueChange}
				   autoSize={{minRows:this.props.component.cp.minRows,maxRows:this.props.component.cp.maxRows}}
				   autoComplete="off" placeholder={this.props.component.cp.help}></TextArea>
			   }

			

			   {
				    type=='fs-switch'&&<Switch   checked={this.state.value===true||this.state.value=='true'}  
					 disabled={this.props.editable==false||this.props.component.cp.editable==false}
					// onChange={(v,event)=>{this.state.value = v;this.valueChange(v)}} 
					 onClick ={(v,event)=>{this.state.value = !this.state.value;this.valueChange(this.state.value)}}></Switch>
			   }

			   {
				   (type=='fs-select'||type=='fs-radio'||type=='fs-checkbox')&&(this.props.component.cp.dsType==null||this.props.component.cp.dsType=='url')&&<FsSelect
				   component={this.props.component} field="value" type={this.props.component.name}
				    url={this.props.component.cp.url} onChange={this.valueChange }
					po={this.props.po}
					debug={this.props.debug}
					editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsSelect>
			   }
			   {
			   				   (type=='fs-select'||type=='fs-radio'||type=='fs-checkbox')&&this.props.component.cp.dsType=='dict'&&<FsSelect
			   				   component={this.props.component} field="value" type={this.props.component.name}

							   po={this.props.po}
			   				      dict={this.props.component.cp.dict} onChange={this.valueChange}
								  debug={this.props.debug}
								  
			   					editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsSelect>
			   }
			   {
			   				   (type=='fs-select'||type=='fs-radio'||type=='fs-checkbox')&&this.props.component.cp.dsType=='listOptions'&&<FsSelect
			   				   component={this.props.component} field="value" type={this.props.component.name}
							   po={this.props.po}
							   debug={this.props.debug}
			   				     listOptions={this.props.component.cp.listOptions} onChange={this.valueChange}
			   					editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsSelect>
			   }

			   {
			   				   (type=='fs-select'||type=='fs-radio'||type=='fs-checkbox')&&this.props.component.cp.dsType=='list'&&<FsSelect
			   				   component={this.props.component} field="value" type={this.props.component.name}
							   po={this.props.po}
							   debug={this.props.debug}
			   				      onChange={this.valueChange }
			   					editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsSelect>
			   }

			   {
			   				   (type=='fs-cascader' ||  type=='fs-cascading') &&<FsSelect
			   				   component={this.props.component} field="value" type={this.props.component.name}
			   				     url={this.props.component.cp.url}  onChange={this.valueChange }
								 po={this.props.po}
								 debug={this.props.debug}
			   					editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsSelect>
			   }

			   {
				   // 转类型

 
					
				    (type=='fs-date'|| type=='fs-date-time' && this.props.component.cp.subType!='dateRange' ) &&(window.isMobile? <FsCalendar component={this.props.component} type={this.props.component.name}
			   				     url={this.props.component.cp.url}  onChange={this.valueChange }
								 po={this.props.po}
			   					editable={this.props.editable!=false&&this.props.component.cp.editable!=false} ></FsCalendar> :	<ConfigProvider locale={zhCN}>
									 <DatePicker value={this.state.value}
									  showTime={type === 'fs-date-time'}
										editable="false" readonly={this.props.debug==true}
										clearable={true} type={this.props.component.cp.subType?this.props.component.cp.subType:'date'}
										onBlur={()=>this.handleBlur(this.props.component)}
										onChange={(moment,dateString)=>{this.state.value  = moment; this.valueDateChange(dateString) }} 
										format={type === 'fs-date' ? 'YYYY-MM-DD': 'YYYY-MM-DD HH:mm'}
										placeholder={this.props.component.cp.subType=='daterange'?'选择日期范围':'选择日期'}>
										</DatePicker>
										</ConfigProvider>)
					
					
					
			   }
			   
			   {
			   				   // 转类型 
			   				    (type=='fs-date' &&this.props.component.cp.subType=='dateRange') &&	<RangePicker value={this.state.value}
			   					 editable="false" readonly={this.props.debug==true}
			   					clearable={true}  
								
			   					 onBlur={()=>this.handleBlur(this.props.component)}
			   					 onChange={(moment,dateString)=>{this.state.value  = moment; this.valueDateChange(dateString); }} 
			   					  format={this.props.component.cp.format?this.props.component.cp.format.toUpperCase():'YYYY-MM-dd'}
			   					  placeholder={this.props.component.cp.subType=='daterange'?'选择日期范围':'选择日期'}>
			   				   	</RangePicker>
			   					
			   } 
			   {
				   (type=='fs-rate' ) &&<Rate value={this.props.component.value}></Rate>
				} 
			 
				
				{
					(type=='fs-code-editor' ) && <FsCodeEditor component={this.props.component} type="fs-code-editor" 
					onChange={this.valueChange }  
					 debug={this.props.debug} 
					 editable={this.props.editable!=false&&this.props.component.cp.editable!=false}></FsCodeEditor>
					
				}
				{
					(type=='fs-img' ) &&<FsUpload  component={this.props.component} type="img" onChange={this.valueChange } 
					  editable={this.props.editable!=false&&this.props.component.cp.editable!=false}
					  ></FsUpload>
				}
				{
					(type=='fs-upload' ) &&<FsUpload  component={this.props.component} type="file" onChange={this.valueChange } 
					  editable={this.props.editable!=false&&this.props.component.cp.editable!=false}
					  ></FsUpload>
				}
				 

			   </div>





		  }
	  }

  render(){
	  
	  var showTitle =  this.props.component.cp.isShowTitle!==false||(window.isReport&&this.props.component.cp.title);
	 // console.log("this.props.keePage.name："+(this.props.keePage?this.props.keePage.name:''));
	 var appCode = this.getUrlParameter("appCode")
	 const {titleType} = this.state
	  if(appCode&&appCode.indexOf("REPORT_")!=-1)
	  { 
		  showTitle = true;
	  }
	//  console.log("sssssss",this.props.component.error);
  return  <div className={`${this.props.component.error&&this.props.component.error!=''&&!(this.props.editable==false||this.props.component.cp.editable==false)?'ant-form-item-has-error':''}`}>

		{
			 
             
			 <div className={`el-form-item`}> 
			 		<div>
						<label className={`el-form-item__label`}
							// onDoubleClick={(e)=>this.onClickFun(e)}
							// onKeyDown={(e)=>this.onClickFun(e)}
							style={{ 
								textAlign:this.props.component.cp.labelPosition!='top'?this.props.component.cp.labelPosition:'left',
								width: this.props.component.cp.labelPosition!='top'?((showTitle?this.props.component.cp.labelWidth+'px':'0px')):'100%',
								display:(showTitle?'block':'none')}}>
							{this.props.debug ? 
							( titleType ? 
							 	<div>
								 <Input
								 	value={this.props.component.cp.title}
								 />
							 	</div>
							:
								<div>
									<span style={{color:'#EB2829'}}>{(this.props.component.cp.required==true?'*':'')}</span>
									{this.props.component.cp.title}
								</div>
							):
							(<div>
								<span style={{color:'#EB2829'}}>{(this.props.component.cp.required==true?'*':'')}</span>
								{this.props.component.cp.title}
							</div>
							)
							}
						</label>
						{
							this.props.component.cp.upload ? 
								<div>
								<Image 
									src={`${window.fileUrl}/api/fs/getById?ids=${this.props.component.cp.upload}`} 
									alt={this.props.component.cp.upload}
									style={{margin: '10px 20px'}}
									width={110}
									height={110}
								/>
							</div> : ''
							}
					</div>
  						<div className={`el-form-item__content`} 
						style={{'marginTop':(this.props.component.cp.labelPosition=='top'?'30px':'0px'),'marginLeft': this.props.component.cp.isShowTitle===true&&this.props.component.cp.labelPosition!='top'?this.props.component.cp.labelWidth+'px':'0px'}}
					
					 
						>
					 
						 {this.renderItem()}
						 {
							 showTitle&& <div style={{height:'0px'}}>
							 {
							 		this.props.debug!=true&&this.props.component.errorMsg!=null&&this.props.component.errorMsg!=''&&<div  style={{lineHeight:'16px',fontSize:'12px',color:'#EB2829'}}> {this.props.component.errorMsg} </div>
							 }
							 </div>
						 }
						 
						
						

							
						</div>
						</div>
			  

		}
	</div>
  }
 }
